/* tslint:disable */
/* eslint-disable */
/**
 * JET Charge Illuminate Web API
 * JET Charge Illuminate Web API
 *
 * The version of the OpenAPI document: 1.0.0
 * Contact: rd@jetcharge.com.au
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from "../runtime";
import type { ConnectorSnapshot } from "./ConnectorSnapshot";
import {
    ConnectorSnapshotFromJSON,
    ConnectorSnapshotFromJSONTyped,
    ConnectorSnapshotToJSON,
} from "./ConnectorSnapshot";

/**
 *
 * @export
 * @interface ChargerSnapshot
 */
export interface ChargerSnapshot {
    /**
     *
     * @type {string}
     * @memberof ChargerSnapshot
     */
    uniqueId?: string;
    /**
     *
     * @type {string}
     * @memberof ChargerSnapshot
     */
    coreConnectionStatus?: string;
    /**
     *
     * @type {string}
     * @memberof ChargerSnapshot
     */
    passthroughConnectionStatus?: string;
    /**
     *
     * @type {Array<ConnectorSnapshot>}
     * @memberof ChargerSnapshot
     */
    connectorSnapshots?: Array<ConnectorSnapshot>;
}

/**
 * Check if a given object implements the ChargerSnapshot interface.
 */
export function instanceOfChargerSnapshot(
    value: object,
): value is ChargerSnapshot {
    return true;
}

export function ChargerSnapshotFromJSON(json: any): ChargerSnapshot {
    return ChargerSnapshotFromJSONTyped(json, false);
}

export function ChargerSnapshotFromJSONTyped(
    json: any,
    ignoreDiscriminator: boolean,
): ChargerSnapshot {
    if (json == null) {
        return json;
    }
    return {
        uniqueId: json["uniqueId"] == null ? undefined : json["uniqueId"],
        coreConnectionStatus:
            json["coreConnectionStatus"] == null
                ? undefined
                : json["coreConnectionStatus"],
        passthroughConnectionStatus:
            json["passthroughConnectionStatus"] == null
                ? undefined
                : json["passthroughConnectionStatus"],
        connectorSnapshots:
            json["connectorSnapshots"] == null
                ? undefined
                : (json["connectorSnapshots"] as Array<any>).map(
                      ConnectorSnapshotFromJSON,
                  ),
    };
}

export function ChargerSnapshotToJSON(value?: ChargerSnapshot | null): any {
    if (value == null) {
        return value;
    }
    return {
        uniqueId: value["uniqueId"],
        coreConnectionStatus: value["coreConnectionStatus"],
        passthroughConnectionStatus: value["passthroughConnectionStatus"],
        connectorSnapshots:
            value["connectorSnapshots"] == null
                ? undefined
                : (value["connectorSnapshots"] as Array<any>).map(
                      ConnectorSnapshotToJSON,
                  ),
    };
}
